import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authService } from '../../services/authService';
import LoginForm from './components/LoginForm';
import AlternativeAuth from './components/AlternativeAuth';
import SecurityBadges from './components/SecurityBadges';
import BrandHeader from './components/BrandHeader';

const Login = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Redirect if already logged in
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleLogin = async (formData) => {
    setLoading(true);
    setError('');

    try {
      const { data, error } = await authService?.signIn(formData?.email, formData?.password);

      if (error) {
        setError(error?.message || 'Login failed. Please check your credentials.');
      } else if (data?.user) {
        // Successful login - AuthContext will handle the state update
        navigate('/dashboard');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-background rounded-2xl shadow-xl border border-border p-8">
          <BrandHeader />
          
          <div className="space-y-8">
            <LoginForm 
              onSubmit={handleLogin}
              loading={loading}
              error={error}
            />
            
            <AlternativeAuth />
            
            <SecurityBadges />
          </div>
          
          <div className="mt-8 pt-6 border-t border-border text-center">
            <p className="text-xs text-muted-foreground">
              © {new Date()?.getFullYear()} ZentriDMS. All rights reserved.
            </p>
            <div className="flex items-center justify-center gap-4 mt-2">
              <button 
                onClick={() => window.location.href = '/privacy-policy'}
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                Privacy Policy
              </button>
              <span className="text-xs text-muted-foreground">•</span>
              <button 
                onClick={() => window.location.href = '/terms-of-service'}
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-muted-foreground">
            Need help? Contact your IT administrator or{' '}
            <button 
              onClick={() => window.location.href = '/support'}
              className="text-primary hover:text-primary/80 transition-colors"
            >
              technical support
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;